// extracted by mini-css-extract-plugin
module.exports = {"fixedHeader":"antd-pro-layouts-header-fixedHeader"};